import React from "react";
import style from './location_error.module.css';

const LocationError = () => {
    return (<>
        <div className={`${style['html']}`}>
            <div className={`${style['body']}`}>
                <div className={`${style['section']}`}>
                    {/* <h1 className={`${style['error']}`}><i class="fa-solid fa-triangle-exclamation"></i></h1> */}
                    <h1 className={`${style['error']}`}><i className="fa-solid fa-map-location-dot"></i></h1>
                    
                    <div className={`${style['page']}`}>
                        Grant location access to continue.
                    </div>
                    {/* <a className={`${style['back-home']}`} href="#!">Back to home</a> */}
                </div>
            </div>
        </div>
    </>);
}

export default LocationError;